<template>
    <svg class="fill-purple dark:fill-white" width="23" height="13" viewBox="0 0 23 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.1028 10.0976C10.8482 10.0976 10.5936 10.0004 10.3995 9.80639L4.29141 3.69823C3.90286 3.30967 3.90286 2.67968 4.29141 2.2913C4.67981 1.9029 5.30966 1.9029 5.69825 2.2913L11.1028 7.69613L16.5073 2.29148C16.8959 1.90308 17.5257 1.90308 17.914 2.29148C18.3028 2.67988 18.3028 3.30986 17.914 3.6984L11.806 9.80656C11.6118 10.0006 11.3573 10.0976 11.1028 10.0976V10.0976Z"/>
    </svg>
</template>

<script>
export default {
    name: 'ArrowDownIcon',
}
</script>
